import { useState } from "react"
import { Alert, Button, Col, Image, Modal, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaFileExport } from "react-icons/fa"
import Get from "../../api/Get"
import Put from "../../api/Put"
import { APPOINTMENT_UPDATE, GET_CHECKLIST_DOCUMENTS_ADJUNTOS } from "../../api/Routes"
import iconRecheck from '../../img/icons/recheck.svg'
import SimpleLoad from "../../loader/SimpleLoad"
import ComponentModalErrorSever from "../ComponentModalErrorSever"

function EnviarDocumentos({t, auth, id}){
    const [sendingDoc, setSendingDoc] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    const [documentosEnviar, setDocumentosEnviar] = useState(null)
    const [existDocuments, setExistsDocuments] = useState(true)
    //console.log(auth)
    const sendDocument = () =>{
        setSendingDoc(true)
        //console.log(id)
        let dataAppointment = {
            id:parseInt(id),
            sendMedicalHistory:true
        }
        Put({url: APPOINTMENT_UPDATE, data: dataAppointment, access_token: auth.data.access_token, header: true})
        .then(response=>{
            setModalShow(false)
            setSendingDoc(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000);
        })
        .catch(error=>{
            console.log("Error al acualizar el envío del historiál clínico", error)
            setModalShow(false)
            setSendingDoc(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        })
    }
    const handleCloseSuccess = () => setShowSuccess(false);
    const handleCloseModalServer = () => setShowModalServer(false)
    const handleCloseModal = () => setModalShow(false);

    const documentosParaEnviar = async () =>{
        setModalShow(true);
        setSendingDoc(true)
        setExistsDocuments(true)
        try {
            const response = await Get({url: `${GET_CHECKLIST_DOCUMENTS_ADJUNTOS}/${id}`, access_token: auth.data.access_token})
            //console.log(response)
            if(response.data.state){
                setSendingDoc(false)
                setDocumentosEnviar(response.data.data)
                const data = response.data.data
                const isColombia = auth.data.company.id === 2
                const hasAdjuntos = isColombia && Array.isArray(data?.adjuntos) && data.adjuntos.length > 0
                const hasOtherDocs = data && (data.ficha || data.historia || data.receta || data.incapacidad
                    || data.recomendacion || data.remision || data.estudios || data.laboratorio || data.notas)
                if (!hasOtherDocs && !hasAdjuntos) {
                    setExistsDocuments(false)
                }
            }else{
                setSendingDoc(false)
                setDocumentosEnviar(null)
                setExistsDocuments(false)
            }
        } catch (error) {
            setSendingDoc(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        }
    }

    return (
        <>
            <div className="text-center">
                <Button size="sm" 
                    variant="outline-secondary" 
                    className="font-size-07rem py-0"
                    onClick={documentosParaEnviar}
                    block
                >
                    <FaFileExport className="pb-1" />
                    {t('enviar_documentos')}
                </Button>
            </div>
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                    </div>                
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
            <Modal show={modalShow} onHide={handleCloseModal} centered className="border-0">
                {sendingDoc && <SimpleLoad />}
                <Modal.Header>¿Está seguro que desea enviar los siguientes documentos?</Modal.Header>
                <Modal.Body>
                    {
                        !existDocuments && 
                        <Alert variant="info">No existen documentos a enviar</Alert>
                    }
                    <ul>
                        {documentosEnviar?.ficha && <li>Ficha epidemiológica.</li>}
                        {documentosEnviar?.historia && <li>Historia clínica.</li>}
                        {documentosEnviar?.receta && <li>Receta.</li>}
                        {documentosEnviar?.incapacidad && <li>Incapacidad.</li>}
                        {documentosEnviar?.recomendacion && <li>Recomendación médica.</li>}
                        {documentosEnviar?.remision && <li>Remisiones.</li>}
                        {documentosEnviar?.estudios && <li>Estudios imagenológicos.</li>}
                        {documentosEnviar?.laboratorio && <li>Laboratorios.</li>}
                        {documentosEnviar?.notas && <li>Notas Aclaratorias.</li>}
                        {auth.data.company.id === 2 && Array.isArray(documentosEnviar?.adjuntos) && documentosEnviar.adjuntos.map((item, index) => (
                            <li key={item.id ?? `adjunto-${index}`}>{item.filename || `Adjunto ${item.id ?? index}`}</li>
                        ))}
                    </ul>

                    <Row>
                        <Col className="text-right">
                            <Button 
                                variant="secondary" 
                                className="btn1"
                                onClick={handleCloseModal}
                            >Cancelar</Button>{' '}
                            <Button 
                                variant="primary" 
                                className="btn1"
                                onClick={sendDocument}
                                disabled={!existDocuments}
                            >Enviar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )

}

export default withTranslation()(EnviarDocumentos)